import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const FooterContainer = styled.footer`
  position: relative;
  z-index: 10;
  background-color: var(--color-surface);
  color: #13519a;
  padding: 2px 30px;
  display: flex;
  justify-content: space-between; /* Les extrêmes collés aux bords */
  align-items: center;
  border-top: 1px solid rgba(255, 255, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }
`;

const Copyright = styled.div`
  flex: 1;
  display: flex;
  font-size: 13px;
  justify-content: flex-start; /* Collé à gauche */
  align-items: center;
  color: #13519a;
`;

const FooterLinks = styled.div`
  flex: 1;
  display: flex;
  justify-content: center; /* Centré */
  align-items: center;
  gap: 16px;

  a {
    color: #13519a;
    text-decoration: none;
    font-size: 12px;
    transition: color 0.3s ease;
    &:hover {
      color: var(--color-accent);
    }
  }
`;

const SocialIcons = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end; /* Collé à droite */
  align-items: center;

  a {
    color: #13519a;
    font-size: 24px;
    text-decoration: none;
    transition: color 0.3s ease, transform 0.3s ease;
    &:hover {
      color: var(--color-accent);
      transform: scale(1.1);
    }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Copyright>
        &copy; {new Date().getFullYear()} ImpactIsol. Tous droits réservés.
      </Copyright>
      <FooterLinks>
        <Link to="/mentions-legales">Mentions légales</Link>
        <Link to="/politique-confidentialite">
          Politique de Confidentialité
        </Link>
      </FooterLinks>
      <SocialIcons>
        <a
          href="https://www.linkedin.com/company/impactisol-calorifuge/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          in
        </a>
      </SocialIcons>
    </FooterContainer>
  );
};

export default Footer;
